import { Animatespin } from "../../components/index";
import localimgpath from "../../js/localimgpath";
import Icons from "../../assets/icon";
import Functions from "./index.function";
const VoteToWin = () => {
  const {
    talentVolteList,
    filteredTalentList,
    isLoading,
    getVisibleItems,
    handleVotelike,
    loadingToHotapi,
    handleVotedislike,
    loadingToNotapi,
  } = Functions();

  return (
    <div className="xs:px-3 sm:px-5 lg:px-5 xl:px-10  sm:py-6  xs:py-5 m-auto lg:pt-10 lg:pb-12">
      <div className="lg:py-10">
        <h2
          className={`text-xl sm:text-3xl lg:text-4xl uppercase text-center font-unboundedBold text-secondary`}
        >
          VOTE TO WIN
        </h2>
      </div>
      {talentVolteList?.data?.vote_images?.length < 1 && (
        <div className="flex items-center justify-center w-full">
          <p className="text-secondary">No user available for Vote to Win</p>
        </div>
      )}
      <div
        className={`relative flex justify-center items-end xs:pt-16 sm:pt-28 xl:pt-32 lg:pt-28 2xl:pt-36 w-full sm:w-[95%] lg:w-[90%]  ${
          filteredTalentList?.length === 1 || filteredTalentList?.length === 2
            ? ""
            : "sm:mx-auto"
        }`}
      >
        {isLoading ? (
          <Animatespin />
        ) : (
          <>
            {getVisibleItems().map((item, index) => (
              <div
                key={item?.id}
                className={`!relative flex sm:h-[20rem] lg:h-[27rem] xl:h-[32.625rem] 2xl:h-[40rem] 3xl:h-[55rem] ${
                  filteredTalentList?.length === 1 ||
                  filteredTalentList?.length === 2
                    ? "w-2/6 xs:rounded-xl sm:rounded-3xl 2xl:rounded-[35px]"
                    : "w-full"
                } h-[13rem] transition-transform duration-500 ${
                  filteredTalentList?.length < 2
                    ? filteredTalentList[0]
                    : index === 1
                    ? "scale-110 z-20 xs:rounded-xl sm:rounded-3xl 2xl:rounded-[35px]"
                    : "scale-90 z-10"
                } ${
                  index === 0
                    ? "!absolute !-bottom-[1.29rem] !-right-[0.6rem] sm:!-bottom-8 lg:!-bottom-11 xl:!-bottom-[3.3rem] 2xl:!-bottom-[0rem] 3xl:!-bottom-[5.5rem] sm:!-right-6 lg:!-right-9 xs:rounded-s-xl sm:rounded-s-3xl 2xl:rounded-s-[35px]"
                    : ""
                } ${
                  index === 2
                    ? "!absolute !-bottom-[1.29rem] !-left-[0.6rem] sm:!-bottom-8 lg:!-bottom-11 xl:!-bottom-[3.3rem] 2xl:!-bottom-[0rem] 3xl:!-bottom-[5.5rem] sm:!-left-6 lg:!-left-9 xs:rounded-e-xl sm:rounded-e-3xl 2xl:rounded-e-[35px]"
                    : ""
                }`}
                style={{ backgroundColor: item.bgColor }}
              >
                <img
                  className={`absolute bottom-0 xs:rounded-xl rounded-3xl w-full left-0 ${
                    filteredTalentList?.length < 2
                      ? filteredTalentList[0]
                      : index === 1
                      ? ""
                      : "blur-[10px] object-cover-talent"
                  }`}
                  src={`${localimgpath.userImage}/${item?.vote_to_win_image}`}
                  alt={`Item ${item?.real_name}`}
                />
                {(filteredTalentList?.length < 2
                  ? filteredTalentList[0]
                  : index === 1) && (
                  <div className="absolute bottom-5 flex xs:space-x-1 space-x-4 w-full justify-center items-center">
                    <button
                      onClick={() => handleVotelike(item?.id)}
                      className="group px-3.5 xs:py-1 sm:px-8 lg:px-10 py-2 flex items-center xs:gap-[2px] sm:gap-1 lg:gap-1 bg-[#FA5738] xs:rounded-md rounded-lg shadow-lg transition-transform duration-300 hover:scale-105 hover:shadow-xl"
                    >
                      {loadingToHotapi ? (
                        <div className="flex justify-center items-center">
                          <div className="animate-spin rounded-full border-t-2 border-b-2 group-hover:border-primary border-secondary lg:w-6 lg:h-6 sm:w-4 sm:h-4 xs:w-3 xs:h-3"></div>
                        </div>
                      ) : (
                        <>
                          <img
                            className="w-3 sm:w-5 lg:w-8 transition-transform duration-300 group-hover:rotate-12 group-hover:scale-125"
                            src={Icons.LikeIcon}
                            alt={Icons.LikeIcon}
                          />
                        </>
                      )}
                    </button>
                    <button
                      onClick={() => handleVotedislike(item?.id)}
                      className="group px-3.5 xs:py-1 sm:px-8 lg:px-10 py-2 flex items-center sm:gap-1 lg:gap-1 bg-[#222831] xs:rounded-md rounded-lg shadow-lg transition-transform duration-300 hover:scale-105 hover:shadow-xl xs:gap-[2px]"
                    >
                      {loadingToNotapi ? (
                        <div className="flex justify-center items-center">
                          <div className="animate-spin rounded-full border-t-2 border-b-2 group-hover:border-primary border-secondary lg:w-6 lg:h-6 sm:w-4 sm:h-4 xs:w-3 xs:h-3"></div>
                        </div>
                      ) : (
                        <>
                          <img
                            className="w-3 sm:w-5 lg:w-8 transition-transform duration-300 group-hover:rotate-12 group-hover:scale-125"
                            src={Icons.disLikeIcon}
                            alt={Icons.disLikeIcon}
                          />
                        </>
                      )}
                    </button>
                  </div>
                )}
              </div>
            ))}
          </>
        )}
      </div>
    </div>
  );
};

export default VoteToWin;
